import React, { Component } from "react";
import { BackTop, Layout } from "antd";
import { connect } from "react-redux";
import { App, Header, Footer, FooterMobile, HeaderMobile } from "..";
import { useMediaQuery } from "react-responsive";

const { Content } = Layout;
const IsMiddleScreenAndMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 1000 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1000 });
  return isDesktop ? children : null;
};
export class WorldCup extends Component {
  state = {
    windowWidth: window.innerWidth,
  };
  render() {
    const { children, className } = this.props;
    return (
      <App {...this.props}>
        <div className={`screen ${className}`}>
          <Layout.Header className="header sticky-header">
            <IsMiddleScreenAndMobile>
              <HeaderMobile fromWorldCup={true} {...this.props} />
            </IsMiddleScreenAndMobile>
            <IsDesktop>
              <Header fromWorldCup={true} {...this.props} />
            </IsDesktop>
          </Layout.Header>

          <Content>
            <div className="size">{children}</div>
          </Content>
          <Layout.Footer className="footer">
            <IsMiddleScreenAndMobile>
              <FooterMobile {...this.props} />
            </IsMiddleScreenAndMobile>
            <IsDesktop>
              <Footer {...this.props} />
            </IsDesktop>
          </Layout.Footer>
        </div>

        <BackTop />
      </App>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorldCup);
